// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.368 7.6a.236.236 0 0 1-.063.11l-3.034 2.96.716 4.186a.236.236 0 0 1-.096.23.233.233 0 0 1-.133.027.247.247 0 0 1-.11-.027L14.92 13.12l-3.771 1.972a.234.234 0 0 1-.343-.247l.716-4.176-3.037-2.96a.237.237 0 0 1-.059-.24.24.24 0 0 1 .189-.157l4.196-.61L14.688 2.9a.243.243 0 0 1 .418 0l1.876 3.802 4.193.61a.237.237 0 0 1 .188.158.237.237 0 0 1 .005.128zM17.475 16.258l-2.318 2.318M7.364 8.674l-3.37 3.374M9.682 16.05l-2.53 2.526M7.786 22.159l7.162-7.162M9.682 11.205 3.15 17.736"
    />
  </svg>
);
export default SvgStar;
